/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Status groups correspond to an action that needs to be taken on the invoice.
 * These should contain the minimum amount of information to determine the next action.
 *
 * CREATED: The invoice metadata has been created and needs to be parsed by DocAI.
 * REVIEW: The parsed invoice has exceptions for Front-End to review.
 * APPROVED: The invoice has no exceptions and is ready to be extracted for payment.
 * COMPLETE: No further action is required on the invoice.
 */
export enum StatusGroup {
    CREATED = 'created',
    REVIEW = 'review',
    APPROVED = 'approved',
    COMPLETE = 'complete',
}
